import Footer from "./components/Footer/Footer";
import Header from "./components/Header/Header";
import styles from "./global.module.css";
import AllFixtures from "./pages/AllFixtures/AllFixtures";
import Home from "./pages/Home/Home";
import { Route, Routes } from "react-router-dom";
import MatchScore from "./pages/MatchScore/MatchScore";
import PrivacyPolicy from "./components/PrivacyPolicy/PrivacyPolicy";
import TermsAndConditions from "./components/TermsAndConditions/TermsAndConditions";
import ContactUs from "./components/ContactUs/ContactUs";
import NewsDetails from "./components/NewsDetails/NewsDetails";
import Appads from "./components/app-ad/Appads";
import SeriesDetails from "./pages/SeriesDetails/SeriesDetails";
import TimerApiCalling from "./components/TimerApiCalling/TimerApiCalling";
import { useEffect } from "react";
import { useDispatch } from "react-redux";
import { homeData } from "./features/home/homeSlice";
import Dashboard from "./pages/adminDashboard/Dashboard";
import Topbar from "./components/Topbar/Topbar";
import AllCampaign from "./components/AllCampaign/AllCampaign";

function App() {
  const dispatch = useDispatch();

  useEffect(() => {
    const intervalId = setInterval(() => {
      dispatch(homeData());
    }, 5000);

    return () => clearInterval(intervalId);

    // dispatch(homeData());
  }, []);
  let pathname = window.location.pathname.split("/")[1];

  return (
    <div className="App">
      <div className="heading">
        {pathname === "admin" || pathname === "login" ? <Topbar /> : <Header />}

        {/* <TimerApiCalling /> */}

        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/app-ads.txt" element={<Appads />} />
          <Route path="/privacy-policy" element={<PrivacyPolicy />} />
          <Route path="/terms-conditions" element={<TermsAndConditions />} />
          <Route path="/contact-us" element={<ContactUs />} />
          <Route path="/fixtures" element={<AllFixtures />} />
          <Route path="/news/:news_id" element={<NewsDetails />} />
          <Route path="/series/:series_id" element={<SeriesDetails />} />
          <Route path="/admin/login" element={<Dashboard />} />
          <Route path="/admin" element={<Dashboard />} />
          <Route path="/admin/create-campaign" element={<Dashboard />} />
          <Route path="/admin/edit-product" element={<Dashboard />} />
          <Route path="/admin/edit-campaign" element={<Dashboard />} />
          <Route path="/admin/all-campaign" element={<Dashboard />} />
          <Route path="/admin/series-list" element={<Dashboard />} />
          <Route path="/admin/all-reward-products" element={<Dashboard />} />
          <Route path="/admin/campaign-detail" element={<Dashboard />} />
          <Route path="/admin/add-products" element={<Dashboard />} />
          <Route path="/newsDetails" element={<NewsDetails />} />
          <Route
            path="/live-score/match/:match_id/:match_status"
            element={<MatchScore />}
          />
        </Routes>
        {pathname === "admin" ? null : <Footer />}
      </div>
    </div>
  );
}

export default App;
